import Vue from 'vue';
export default Vue.extend({
    name: 'QMenuTree',
    props: {
        variables: {
            type: Object
        },
        clickHandler: {
            type: Function,
            required: true
        },
        parent: {
            type: String,
            default: null
        },
        anchor: {
            type: String,
            default: ''
        },
        self: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    computed: {},
    methods: {}
});
